export default "__VITE_ASSET__DaER03Xr__"